export default "__VITE_ASSET__Dy$s_O1P__"